import {
  BookUser,
  ClipboardList,
  GraduationCap,
  LayoutDashboard,
  Receipt,
  type LucideIcon,
} from 'lucide-react';

import type { TabListItem } from '~shared/components/tab-list';

type HubTab = {
  segment: string;
  label: string;
  icon: LucideIcon;
};

const HUB_TABS: Array<HubTab> = [
  { segment: 'summary', label: 'Summary', icon: LayoutDashboard },
  { segment: 'contacts', label: 'Contacts', icon: BookUser },
  { segment: 'classes', label: 'Classes', icon: GraduationCap },
  {
    segment: 'transactions',
    label: 'Transactions and Billing',
    icon: Receipt,
  },
  { segment: 'notes', label: 'Notes', icon: ClipboardList },
];

export const buildFamilyHubTabs = (
  familyId: string,
  pathname: string,
): Array<TabListItem> =>
  HUB_TABS.map((tab) => {
    const href = `/families/${familyId}/${tab.segment}`;
    return {
      href,
      label: tab.label,
      icon: tab.icon,
      active: pathname.includes(`/families/${familyId}/${tab.segment}`),
    };
  });
